import { render, staticRenderFns } from "./PopRichText.vue?vue&type=template&id=29dd4978&scoped=true&"
import script from "./PopRichText.vue?vue&type=script&lang=js&"
export * from "./PopRichText.vue?vue&type=script&lang=js&"
import style0 from "./PopRichText.vue?vue&type=style&index=0&id=29dd4978&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dd4978",
  null
  
)

export default component.exports